import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { HisAuthCoreModule } from './auth/his-auth-core.module';
import { HisCommunicationlogCoreModule } from './communicationlog/communicationlog-core.module';
import { HTTPListener, HTTPStatus } from './core/component/loader/his-httplistener.service';
import { HisCoreCoreModule } from './core/his-core-core.module';
import { HisBootstrapService } from './core/service/base/his-bootstrap.service';
import { HisDynamicFormCoreModule } from './dynamicform/his-dynamicform-core.module';
import { HisGenericsearchCoreModule } from './genericsearch/his-genericsearch-core.module';
import { HisSharedModule } from './his-shared.module';
import { HisInputPersonalAgreementCoreModule } from './input/component/inputPersonalAgreement/his-input-personal-agreement-core.module';
import { HisJobsCoreModule } from './jobs/his-jobs-core.module';
import { HisPagesCoreModule } from './pages/his-pages-core.module';
import { HisStartpageComponent } from './pages/startpage/his-startpage.component';
import { HisProblemCaseCoreModule } from './problemcase/his-problem-case-core.module';
import { HisTableCoreModule } from './table/his-table-core.module';
import { HisTranslationCoreModule } from './translation/his-translation-core.module';
import { HisTreeCoreModule } from './tree/his-tree-core.module';
import { HisFileUploadCoreModule } from './upload/his-file-upload-core.module';

const ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        component: HisStartpageComponent,
        resolve: { boot: HisBootstrapService }
    },
    {
        path: 'hisng',
        loadChildren: () => import( './pages/his-pages-core.module' ).then( m => m.HisPagesCoreModule ),
        resolve: { boot: HisBootstrapService }
    }
];

/**
 * The HIS Angular library. Import HisCoreModule in the root module of
 * all HIS Angular projects.
 */
@NgModule( {
    imports: [
        HisSharedModule,
        HisAuthCoreModule,
        HisCoreCoreModule,
        HisDynamicFormCoreModule,
        HisGenericsearchCoreModule,
        HisJobsCoreModule,
        HisPagesCoreModule,
        HisTableCoreModule,
        HisTreeCoreModule,
        HisTranslationCoreModule,
        HisFileUploadCoreModule,
        HisCommunicationlogCoreModule,
        RouterModule.forChild( ROUTES ),
        HisProblemCaseCoreModule,
        HisInputPersonalAgreementCoreModule,
    ],

    exports: [
        HisSharedModule,
        HisAuthCoreModule,
        HisCoreCoreModule,
        HisDynamicFormCoreModule,
        HisGenericsearchCoreModule,
        HisJobsCoreModule,
        HisTableCoreModule,
        HisTreeCoreModule,
        HisTranslationCoreModule,
        HisFileUploadCoreModule,
        HisCommunicationlogCoreModule,
        HisProblemCaseCoreModule,
        HisInputPersonalAgreementCoreModule,
    ],

    providers: [
        Title,
        HTTPListener,
        HTTPStatus,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HTTPListener,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
    ]
} )
export class HisCoreModule {

    constructor() {
        const parentModule = inject(HisCoreModule, { optional: true, skipSelf: true });

        if ( parentModule ) {
            throw new Error(
                'HisCoreModule may be imported in AppModule only. Use HisSharedModule instead.' );
        }
    }
}
